interface SectionItemProps extends React.PropsWithChildren {
  className?: string;
  style?: React.CSSProperties;
}

const SectionItem: React.FC<SectionItemProps> = ({
  className,
  style,
  children,
}) => (
  <div
    className={className}
    style={{
      border: "2px solid #E6E6E6",
      borderRadius: "8px",
      padding: "16px",
      ...style,
    }}
  >
    {children}
  </div>
);

export { SectionItem };
